import { lazy } from 'react';

const ReenvioDTEPage = lazy(() => import('../../operaciones/reenvio-dte/ReenvioDTEPage.jsx'));

const operacionesRoutes = [
	{
		path: 'operaciones',
		children: [
			{ path: 'reenvio-dte', element: <ReenvioDTEPage /> },
		],
	},
];

export default operacionesRoutes;
